import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AuthService,
  OccEndpointsService,
  UserIdService,
} from '@spartacus/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MaterialsUKService {
  
  public asmenabled: boolean = false;

  userLoggedIn$: Observable<boolean> = this.authService.isUserLoggedIn();
  seasonValue$ = new BehaviorSubject<string>('');
  constructor(
    private occ:OccEndpointsService,
    private http: HttpClient,
    private occEndPointsService: OccEndpointsService,
    private userIdService: UserIdService,
    private authService: AuthService
  ) {
    this.asmenabled = localStorage.getItem('showASM') === 'true';
  }
  fetchUserUrl() {
    let partUrl = '/users/current';
    this.userIdService.getUserId().subscribe((item) => {
      if (item && this.asmenabled) partUrl = `/users/${item}`;
    });

    return partUrl;
  }

  getShippingLocationData() {
    const shippingLocationUrl = this.occEndPointsService.buildUrl(
      `${this.fetchUserUrl()}/materialOrder/shippingLocation?fields=DEFAULT`
    );
    return this.http.get(shippingLocationUrl);
  }
  getmaterailData() {
    const materailUrl = this.occEndPointsService.buildUrl(
      `${this.fetchUserUrl()}/materialOrder/getMaterials?fields=DEFAULT`
    );
    return this.http.get(materailUrl);
  }

  getmaterailblock() {
    const materailUrl1 = this.occEndPointsService.buildUrl(
      `${this.fetchUserUrl()}/materialOrder/prebookOrderCheck?fields=DEFAULT`
    );
    return this.http.get(materailUrl1);
  }
  

  submitMaterialData(materialData: any) {
    const submitMaterialUrl = this.occEndPointsService.buildUrl(
      `${this.fetchUserUrl()}/materialOrder/submitMaterialOrder`
    );
        return this.http.post(submitMaterialUrl, materialData, { responseType: 'text' });
  }

/*   submitMaterialData(materialData: any): Observable<any> {
    const submitMaterialUrl = this.occEndPointsService.buildUrl(
      `${this.fetchUserUrl()}/materialOrder/submitMaterialOrder`
    );
    return this.http.post(submitMaterialUrl, JSON.stringify(materialData), {
      responseType: 'text',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } */

  checkUserLoggedIn() {
    this.userLoggedIn$ = this.authService.isUserLoggedIn();
    this.userLoggedIn$.subscribe((data) => {});
  }

  getMaterialsSeasonDropdown(value: string) {
    const url = this.occEndPointsService.buildUrl(`${this.fetchUserUrl()}/materialOrder/seasonDropdown/${value}?fields=FULL`);
    return this.http.get(url);
  }
  sendMaterialDropdownValue(value: string) {
    this.seasonValue$.next(value);
  }
  getMaterialDropdownValue() {
    return this.seasonValue$.asObservable();
  }

  filterstatus(season: any) {
    const url = this.occEndPointsService.buildUrl(`${this.fetchUserUrl()}/materialOrder/filterStatus?fields=FULL&selectedSeason=${season}`);
    return this.http.get(url);
  }

  fetchMaterialOrdersList(season: any) {
    const url = this.occEndPointsService.buildUrl(`${this.fetchUserUrl()}/materialOrder/myMaterialOrdersList/${season}?fields=DEFAULT`);
    return this.http.get(url);
  }

  fetchMaterialOrderDetail(dropdownValue: any, orderId: string) {
    const url = this.occEndPointsService.buildUrl(`${this.fetchUserUrl()}/materialOrder/myMaterialOrders/${dropdownValue}/${orderId}?fields=DEFAULT`);
    return this.http.get(url);
  }
  getlink(componentName:string){
  
      const url = this.occ.buildUrl("/cms/components/"+componentName);
       return this.http.get(url);
    
  }
  getDigitalConsent(value: string){
    const url = this.occEndPointsService.buildUrl(`${this.fetchUserUrl()}/materialOrder/digitalConsent/${value}?fields=DEFAULT`);
    return this.http.post(url, {}, { responseType: 'text' });
  }
  getsavematerial(){
    const url = this.occ.buildUrl(`${this.fetchUserUrl()}/materialOrder/getMaterialsCart?fields=DEFAULT`)
    return this.http.get<any>(url)
  }
  submitsaveMaterialData(savematerialData: any) {
    const submitMaterialUrl = this.occEndPointsService.buildUrl(
      `${this.fetchUserUrl()}/materialOrder/cart`
    );
        return this.http.post(submitMaterialUrl, savematerialData, { responseType: 'text' });
  }
}
